import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const tAndCApi = createAsyncThunk(
  "tAndC",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/fd/terms&Condition",
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const tAndCSlice = createSlice({
  name: "tAndC",
  initialState: {
    data: [],
    errors: [],
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(tAndCApi.pending, (state) => {
        state.status = "loading";
        state.errors = [];
      })
      .addCase(tAndCApi.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = "idle";
      })
      .addCase(tAndCApi.rejected, (state, action) => {
        state.errors.push(action.payload);
        state.status = "idle";
      });
  },
});

export default tAndCSlice.reducer;
